import {
  FormHelperText,
  InputLabel,
  OutlinedInput,
  InputAdornment
} from "@mui/material";
import { Field, ErrorMessage } from "formik";
import React from "react";

const InputField = ({
  label,
  required,
  endAdornment,
  startAdornment,
  ...props
}) => {
  return (
    <>
      <InputLabel htmlFor={props.id || props.name}>
        {label}
        {required && <span style={{ color: "red" }}>*</span>}
      </InputLabel>

      <Field name={props.name}>
        {({ field }) => (
          <OutlinedInput
            {...field}
            {...props}
            id={props.id || props.name}
            endAdornment={
              endAdornment ? (
                <InputAdornment position="end">
                  {endAdornment}
                </InputAdornment>
              ) : null
            }
            startAdornment={
              startAdornment ? (
                <InputAdornment position="start">
                  {startAdornment}
                </InputAdornment>
              ) : null
            }
            error={Boolean(props.error)}
          />
        )}
      </Field>

      <ErrorMessage name={props.name}>
        {(error) => (
          <FormHelperText error id={`${props.name}-error`}>
            {error}
          </FormHelperText>
        )}
      </ErrorMessage>
    </>
  );
};

export default InputField;
